module.exports = __webpack_public_path__ + "static/media/KidsSDGLogo.532dcde7.png";